import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Default from 'components/breakpoints/Default';
import { AWS_BUCKET_URL } from 'toolkit/constants';
import { countSlipEntries } from 'toolkit/betBuilder';

const Footer = () => {
  const { t } = useTranslation('translations', { useSuspense: false });
  const user = useSelector((state) => state.auth.user);
  const betSlip = useSelector((state) => state.betSlip);
  const location = useLocation();

  // CSS filter to colorize black SVG icons to primary color (#AF021F)
  const activeIconFilter =
    'brightness(0) saturate(100%) invert(8%) sepia(94%) saturate(6288%) hue-rotate(352deg) brightness(98%) contrast(115%)';

  const navItems = [
    {
      key: 'home',
      to: '/',
      label: t('start'),
      icon: `${AWS_BUCKET_URL}/Icons/home.svg`,
      isActive: location.pathname === '/' || location.pathname === '/start'
    },
    {
      key: 'sport',
      to: '/sport',
      label: t('sport'),
      icon: `${AWS_BUCKET_URL}/Icons/sports.svg`,
      isActive: location.pathname === '/sport'
    },
    {
      key: 'live',
      to: '/live',
      label: t('live'),
      icon: `${AWS_BUCKET_URL}/Icons/live.svg`,
      isActive: location.pathname === '/live'
    },
    user === null
      ? {
        key: 'login',
        to: '/login',
        label: t('loginTitle'),
        icon: `${AWS_BUCKET_URL}/Icons/login.svg`,
        isActive: location.pathname === '/login'
      }
      : {
        key: 'mybets',
        to: '/mybets',
        label: t('mybets'),
        icon: `${AWS_BUCKET_URL}/Icons/my-bets-inactive.svg`,
        isActive: location.pathname === '/mybets'
      }
  ];

  const itemsWithSlip =
    betSlip.bets.length > 0
      ? [
        navItems[0],
        navItems[1],
        {
          key: 'bet-slip',
          to: '/bet-slip',
          label: t('betSlip', 'Bet Slip'),
          badge: countSlipEntries(betSlip.bets),
          subLabel: betSlip.totalOdds || null,
          isActive: location.pathname === '/bet-slip'
        },
        navItems[2],
        navItems[3]
      ]
      : navItems;

  if (location.pathname === '/slot-game' || location.pathname === '/casino') return <Fragment />;
  return (
    <Default>
      <footer
        className="mobile-footer border-top bg-white px-0 w-100 d-flex"
        style={{ height: 'var(--footer-height)', minHeight: 'var(--footer-height)', paddingTop: 0, paddingBottom: 0 }}>
        <nav className="d-flex align-items-center justify-content-between gap-0 py-0 w-100 h-100">
          {itemsWithSlip.map((item) => (
            <NavLink
              key={item.key}
              end
              to={item.to}
              className={({ isActive }) =>
                [
                  'footer-item text-decoration-none d-flex flex-column align-items-center justify-content-center flex-fill position-relative',
                  isActive || item.isActive ? 'fw-semibold' : ''
                ].join(' ')
              }
              style={{ padding: '6px 0', fontSize: '13px', lineHeight: 1.3, maxHeight: '56px', height: 'auto' }}>
              {item.badge ? (
                <span
                  className="bg-primary position-absolute text-white d-flex align-items-center justify-content-center fw-bold"
                  style={{
                    top: '-10px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    fontSize: '11px',
                    lineHeight: 1,
                    minWidth: '20px'
                  }}>
                  {item.badge}
                </span>
              ) : null}
              {item.icon ? (
                <img
                  width="24"
                  height="22"
                  src={item.icon}
                  alt={item.label}
                  style={{ filter: item.isActive ? activeIconFilter : 'none' }}
                />
              ) : null}
              <span
                className="text-truncate"
                style={{
                  maxWidth: '70px',
                  color: item.isActive ? 'var(--bs-primary)' : '#212529'
                }}>
                {item.label}
              </span>
              {item.subLabel ? (
                <span className="text-primary fw-semibold" style={{ fontSize: '12px' }}>
                  {item.subLabel}
                </span>
              ) : null}
            </NavLink>
          ))}
        </nav>
      </footer>
    </Default>
  );
};

export default Footer;
